import React from "react";
import {useTranslation} from "react-i18next";
import {Role} from "./Role";
import {Application} from "../applications/Application";
import {formatApplicationRoleHint} from "./ApplicationRoles";
import {InfoIcon} from "../../shared/components/forms/InfoIcon";

export function ApplicationRoleInfoIcon(props: {application: Application, role: Role}) {
  const {t} = useTranslation();
  const infoText = formatApplicationRoleHint(props.application, props.role, t);

  if (!infoText) {
    return null;
  }

  return (
    <InfoIcon text={infoText} />
  );
}
